/**
 *  TasksMenu script file
**/
import { TASK_STATUSES } from '@/api/campaignsService'
import { ACTIONS, MODULE_NAME } from '@/store/campaigns'
import { mapActions, mapState } from 'vuex'
// import 'core-js/proposals/array-grouping-stage-3-2'

const TASK_POOLING_INTERVAL = 5000

export default {
  name: 'TasksMenu',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      statuses: TASK_STATUSES,
      taskPoolingInterval: null
    }
  },
  computed: {
    ...mapState(MODULE_NAME, {
      tasks: 'copy_tasks'
    }),
    numRunningTasks () {
      return this.tasks.results.filter(t => t.status === TASK_STATUSES.RUNNING).length
    },
    groupedTasks () {
      return Object.entries(this.tasks.results.reduce((acc, t) => {
        const key = t.updated_at && new Date(t.updated_at).toLocaleDateString()
        acc[key] = acc[key] || []
        acc[key].push(t)
        return acc
      }, {})).map((e) => ({ date: e[0], tasks: e[1] }))
    }
  },
  mounted () {
    this.taskPoolingInterval = window.setInterval(() => {
      if (this.numRunningTasks > 0) {
        this[ACTIONS.FETCH_COPY_TASKS]()
      }
    }, TASK_POOLING_INTERVAL)
  },
  beforeDestroy () {
    window.clearInterval(this.taskPoolingInterval)
  },
  methods: {
    ...mapActions(MODULE_NAME, [ACTIONS.FETCH_COPY_TASKS, ACTIONS.DELETE_COPY_TASKS]),
    updateScrollbar () {
      if (this.$refs.scrollbar) this.$refs.scrollbar.update()
    },
    async deleteTasks () {
      await this[ACTIONS.DELETE_COPY_TASKS]()
      await this[ACTIONS.FETCH_COPY_TASKS]({ page: this.tasks.meta.page })
    },
    loadMore () {
      this[ACTIONS.FETCH_COPY_TASKS]({ reset: false, page: this.tasks.meta.page + 1 })
    }
  }
}
